module.exports = __webpack_public_path__ + "img/FanClash-Logo-01.2909d619.png";